package com.nonopn.skydome.common.app.pages.main.window

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.nonopn.skydome.common.app.pages.main.model.MainScreenModel
import com.nonopn.skydome.common.app.pages.main.view.Map

@Composable
fun MainScreenLargeScreen(
    modifier: Modifier,
    model: MainScreenModel
) {
    Map(modifier, model)
}
